/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ViewFaasModal({ data, type }) {
  const setModal = useContext(ModalContext);
  const [iframeKey, setIframeKey] = useState(1);

  const replaceId = {
    '{id}': _.get(data, 'attributes.rptax_land_application_id'),
    '{historyId}': _.get(data, 'id'),
  };
  const url =
    type === 'history'
      ? c.FAAS_HISTORY_URL.replace(/{id}|{historyId}/gi, (match) => {
          return replaceId[match];
        })
      : c.FAAS_URL.replace('{id}', _.get(data, 'id'));

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const src = `${
    process.env.REACT_APP_WS
  }${url}?bearer_token=${token}&email=${_.get(authProfile, 'email')}`;

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
  }, []);

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="FAAS"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewFaasModal.defaultProps = {
  data: {},
  type: '',
};

ViewFaasModal.propTypes = {
  data: PropTypes.instanceOf(Object),
  type: PropTypes.string,
};

const mapStateToProps = () => {};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewFaasModal);
